import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const leiColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'lei',
  headerName: 'LEI',
  initialHide: true,
};
